// GTM Event Names
export const GTM_EVENTS = {
  CLIENT_CREATION: 'client_creation',
  ACCOUNT_LOGIN_SUCCESS: 'account_login_success',
  PURCHASE_COMPLETED: 'purchase_completed',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_CANCELLED: 'payment_cancelled',
  DEMO_ACCOUNT_INITIATED: 'demo_account_initiated',
  FUNDED_ACCOUNT_INITIATED: 'funded_account_initiated',
  CHALLENGE_PROGRESS_UPDATE: 'challenge_progress_update',
  FEATURE_USAGE: 'feature_usage',
} as const;

// GTM Event Categories
export const GTM_CATEGORIES = {
  CLIENT_CREATION_FUNNEL: 'Client Creation Funnel',
  USER_MANAGEMENT: 'User Management',
  CHALLENGE_PURCHASE: 'Challenge Purchase',
  ACCOUNT_MANAGEMENT: 'Account Management',
  CHALLENGE_MANAGEMENT: 'Challenge Management',
  PLATFORM_INTERACTION: 'Platform Interaction',
} as const;

// GTM Form Names
export const GTM_FORM_NAMES = {
  CREATE_ACETRADE_CLIENT: 'Create AceTrade Client Form',
  ENTER_SECURITY_DETAILS: 'Enter Security Details Form',
} as const;

// Login Tracking Configuration
export const GTM_LOGIN = {
  ACTION: 'Login',
  LABEL: 'Successful Login',
} as const;

// Purchase Tracking Configuration
export const GTM_PURCHASE = {
  ACTION: 'Successful Payment',
  LABEL: 'Paid Challenge Purchased',
} as const;

// Payment Failed Tracking Configuration
export const GTM_PAYMENT_FAILED = {
  ACTION: 'Payment Failed',
  LABEL: 'Paid Challenge Payment Failure',
} as const;

// Payment Cancelled Tracking Configuration
export const GTM_PAYMENT_CANCELLED = {
  ACTION: 'Payment Cancelled',
  LABEL: 'Paid Challenge Payment Cancel',
} as const;

// Challenge Progress Tracking Configuration
export const GTM_CHALLENGE_PROGRESS = {
  ACTION: 'Progress Update',
} as const;

// Feature Usage: Rewind Tracking Configuration
export const GTM_FEATURE_USAGE_REWIND = {
  ACTION: 'Used',
  LABEL: 'Rewind Button Click',
  FEATURE_NAME: 'Rewind',
} as const;

// Demo Account Tracking Configuration
export const GTM_DEMO_ACCOUNT = {
  ACTION: 'Initiated',
  LABEL: 'Demo Account Creation Started',
} as const;

// Funded Account Tracking Configuration
export const GTM_FUNDED_ACCOUNT = {
  ACTION: 'Initiated',
  LABEL: 'Funded Account Creation Started',
} as const;

// Client Creation Steps Configuration
export const GTM_CLIENT_CREATION_STEPS = {
  STEP_1: {
    step: '1',
    action: 'Step 1 Complete',
    label: 'Initial Client Info Submitted',
  },
  STEP_2: {
    step: '2',
    action: 'Step 2 Complete',
    label: 'Email & Password Submitted',
  },
  STEP_3: {
    step: '3',
    action: 'Email Verification Screen Displayed',
    label: 'Verify Email Prompt Shown',
  },
  STEP_4: {
    step: '4',
    action: 'Email Verified',
    label: 'Email Verification Successful',
  },
  STEP_4_ERROR: {
    step: '4',
    action: 'Error',
    label: 'Email Verification Link Expired',
  },
  STEP_5: {
    step: '5',
    action: 'Phone Verified',
    label: 'Phone Verification Successful',
  },
} as const;
